"use client";
import { useMediaQuery } from "@mui/material";
import { convertWindDirection, theme } from "../utils/Common";
import MobilePage from "./mobile";
import PCPage from "./pc";
import { ThemeProvider } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { getWeatherData, getWeatherMeeting } from "../request/requestList";
import { pageSet } from "@/app/utils/pageSet";
import { useLanguage } from "@/app/utils/LanguageContext";
import { adobeData, updateMetaTag } from "@/app/utils/Common";
const HomePage: React.FC<any> = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down("lg")) ?? false;
  const { state: lang } = useLanguage();
  const { t, langCode } = lang;
  const [weatherData, setWeatherData] = useState<any>([]);
  const [STData, setSTData] = useState<any>([]);
  const [HVData, setHVData] = useState<any>([]);
  const [stGoingData, setStGoingData] = useState<any>([]);
  const [hvGoingData, setHvGoingData] = useState<any>([]);
  const [defaultTab, setDefaultTab] = useState("");
  const sortAndPadArray = (items: any) => {
    if (!items) return;
    const targetOrder = ["A", "B", "C", "D"];
    const result = Array(4).fill("");
    items.forEach((item: any) => {
      const location = item.location;
      const index = targetOrder.indexOf(location);
      if (index !== -1) {
        result[index] = item;
      }
    });

    return result;
  };
  const getRenderData = (resData: any) => {
    const sortSectional = sortAndPadArray(resData?.sectional);
    const sec = sortSectional?.map((item: any) => {
      return {
        date: item?.date,
        time: item?.time,
        avgWindDirection: convertWindDirection(item?.avgCorrectedWindDirection),
        avgWindSpeed: item?.avgCorrectedWindSpeed,
        gustWindSpeed: item?.correctedGustSpeed,
      };
    });
    const result = {
      racecourse: resData.racecourse,
      sectional: sec,
      weatherStation: resData?.weatherStation
        ? {
            date: resData?.weatherStation?.date,
            time: resData?.weatherStation?.time,
            supplyVoltage: resData?.weatherStation?.supplyVoltage,
            relativeHumidity: resData?.weatherStation?.relativeHumidity,
            temperature: resData?.weatherStation?.temperature,
            solarRadiation: resData?.weatherStation?.solarRadiation,
            sunshineHour: resData?.weatherStation?.sunshineHour,
            pressure: resData?.weatherStation?.pressure,
            correctedGustSpeedDailyMax:
              resData?.weatherStation?.correctedGustSpeedDailyMax,
            relativeHumidityDailyMax:
              resData?.weatherStation?.relativeHumidityDailyMax,
            relativeHumidityDailyMin:
              resData?.weatherStation?.relativeHumidityDailyMin,
            temperatureDailyMax: resData?.weatherStation?.temperatureDailyMax,
            temperatureDailyMin: resData?.weatherStation?.temperatureDailyMin,
            rainFallPrecipitation1Min:
              resData?.weatherStation?.rainFallPrecipitation1Min,
            rainFallPrecipitation10Min:
              resData?.weatherStation?.rainFallPrecipitation10Min,
            rainPrecipitationDailyTotal:
              resData?.weatherStation?.rainPrecipitationDailyTotal,
            soilVolumeticWaterContent:
              resData?.weatherStation?.soilVolumeticWaterContent,
            soilMoistureLoss1Min: resData?.weatherStation?.soilMoistureLoss1Min,
            soilMoistureLossDailyTotal:
              resData?.weatherStation?.soilMoistureLossDailyTotal,
            soilMoistureLoss24H: resData?.weatherStation?.soilMoistureLoss24H,
            status: resData?.weatherStation?.status,
            isValid: resData?.weatherStation?.isValid,
          }
        : "",
    };
    return result;
  };
  const getWindData = () => {
    getWeatherData().then((res: any) => {
      setWeatherData(res?.weather);
      const stList: any = [];
      const hvList: any = [];
      res?.weather?.map((item: any) => {
        if (item.racecourse === "HV") {
          hvList.push(getRenderData(item));
        }
        if (item.racecourse === "ST") {
          stList.push(getRenderData(item));
        }
      });
      console.log("weatherList", hvList, stList);
      setHVData(hvList);
      setSTData(stList);
    });
  };
  const getDefaultTab = (stData: any, hvData: any) => {
    let result = "ST";
    if (stData && hvData) {
      result = "ST";
    } else if (!stData && hvData) {
      result = "HV";
    } else if (stData && !hvData) {
      result = "ST";
    }
    console.log("defaultTab", result);
    setDefaultTab(result);
  };
  const getMeetingData = () => {
    getWeatherMeeting().then((res) => {
      const stMeetingList: any = [];
      const hvMeetingList: any = [];
      res?.commonMeetings?.map((item: any) => {
        if (item.venueCode === "ST") {
          stMeetingList.push(item);
        }
      });
      res?.commonMeetings?.map((item: any) => {
        if (item.venueCode === "HV") {
          hvMeetingList.push(item);
        }
      });
      getDefaultTab(stMeetingList[0], hvMeetingList[0]);
      setStGoingData(stMeetingList[0]);
      setHvGoingData(hvMeetingList[0]);
      console.log("getMeetingData", res, stMeetingList[0], hvMeetingList[0]);
    });
  };
  useEffect(() => {
    updateMetaTag(langCode, pageSet.weather);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });
    getWindData();
    getMeetingData();
  }, []);
  const handleRefresh = () => {
    getWindData();
    getMeetingData();
  };
  return (
    <ThemeProvider theme={theme}>
      {isMobile ? (
        <MobilePage
          stGoingData={stGoingData}
          hvGoingData={hvGoingData}
          stData={STData}
          hvData={HVData}
          weatherData={weatherData}
          refresh={handleRefresh}
          defaultTab={defaultTab}
        />
      ) : (
        <PCPage
          stGoingData={stGoingData}
          hvGoingData={hvGoingData}
          stData={STData}
          hvData={HVData}
          weatherData={weatherData}
          refresh={handleRefresh}
          defaultTab={defaultTab}
        />
      )}
    </ThemeProvider>
  );
};
export default HomePage;
